const initialState = {
    basicSavePermissions: {},
    basicSaveLists: [],
    basicSaveDetails: {},
    caseLogsData: [],
    reportDetailsList: {},
    reportDetailsCashless: {},
    updateReportDetailCashless: {},
    basicSaveStatus: [],
    treatingDoctorData: [],
    referralDoctorData: [],
    familyDoctorData: [],
    pathologistDoctorData: [],
    radiologistDoctorData: [],
    pharmacyData: [],
    relatedSearchListData: [],
    bulletManagementData: [],
    bulletManagementClientCompanyId: null,
    caseSpocTeams: null,
    caseSpocTeamsHealthId: null,
    loadingCaseSpocTeams: false,
    foPendingWorkListData: [],
    reportMakerPendingWorkListData: [],
    qcManagerPendingWorkListData: [],
    bulletManagementAllocationData: [],
    bulletManagementClaimData: [],
    assignFoAllocationData: [],
    foDraftData: [],
    deleteFoDraftData: {},
    deleteFoDocumentData: {},
    saveFoDocumentNameData: {},
    deletedFoDocumentsData: {},
    loadingDeletedFoDocuments: false,
    claimFollowUpChangeData: [],
    claimFollowUpEscalationData: [],
    internalTriggerData: [],
    singleInternalTriggerData: [],
    internalTriggerDocumentData: [],
    newFoRequestData: [],
    investigationExternalData: [],
    reinvestigationExternalData: [],
    claimFollowUpData: [],
    claimFollowUpDocumentData: [],
    foPendingWorkData: [],
    managersClaimDecisionData: [],
    reportMakerAllocation: [],
    reportMakerAllocationData: [],
    reportUploadDocumentData: null,
    deleteHealthReportData: null,
    deletingHealthReportId: null,
    qcManagerAllocationData: [],
    reportForQCData: [],
    reportForTeamLeaderQCData: [],
    reportForSubmissionData: [],
    finalCloseData: [],
    finalClosureDocumentData: [],
    fqcRemarkFo: [],
    sendForRereport: [],
    reworkRemarkData: [],
    requestChangeDecisionData: [],
    acceptRejectRequestDecisionData: [],
    editChangeDecisionData: [],
    reportDetailsData: [],
    allReportDetailsData: [],
    reportMakerRemarkData: [],
    singleReportDetailsData: [],
    changedBasicSaveStatus: [],
    allocationStatusData: [],
    reworkStatusData: [],
    foChangeStatusData: [],
    foDocumentData: [],
    withdrawCaseFoData: [],
    resendALToFOData: [],
    editTaskFieldOfficerData: [],
    forceFoFinalSubmittedData: [],
    fqcSendToFoData: [],
    fqcSendToQcData: [],
    loadingReportUploadDocument: false,
    loadingDeleteHealthReport: false,
    loadingBasicSave: false,
    loadingReportDetailsCashless: false,
    loadingUpdateReportDetailsCashless: false,
    loadingClaimTypeSave: false,
    loadingtriggerSave: false,
    loadingTaskManagementSave: false,
    loadingCaseDetailsSave: false,
    loadingCaseHospitalDetailsSave: false,
    loadingUploadRemarksSave: false,
    loadingtatSave: false,
    loadingremarkSave: false,
    errorsBasicSave: {},
    errorsReportDetailsCashless: {},
    errorsUpdateReportDetailsCashless: {},
    errorsClaimTypeSave: {},
    errorstriggerSave: {},
    errorsTaskManagementSave: {},
    errorsCaseDetailsSave: {},
    errorstatSave: {},
    errorsUploadRemarksSave: {},
    errorsRemarksSave: {},
    errorsRelatedSearchList: {},
    errorsBulletAllocation: {},
    errorsBulletClaimTeam: {},
    errorsFoPendingWorkList: {},
    errorsReportMakerPendingWorkList: {},
    errorsQcManagerPendingWorkList: {},
    errorsAssignFoAllocation: {},
    errorsDeleteFoDraft: {},
    errorsDeleteFoDocument: {},
    errorsSaveFoDocumentName: {},
    errorsDeletedFoDocuments: {},
    errorsAllocationStatus: {},
    errorsNewFoRequest: {},
    errorsReworkStatus: {},
    errorsFoChangeStatus: {},
    errorsFoDocument: {},
    errorsInvestigationExternal: {},
    errorsReinvestigationExternal: {},
    errorsWithdrawCaseFo: {},
    errorsResendALToFO: {},
    errorsForceFoFinalSubmitted: {},
    errorsFqcSendToFo: {},
    errorsFqcSendToQc: {},
    errorsClaimFollowUpChange: {},
    errorsClaimFollowUpEscalation: {},
    errorsInternalTrigger: {},
    errorsSingleInternalTrigger: {},
    errorsInternalTriggerDocument: {},
    errorsCLaimFollowUp: {},
    errorsCLaimFollowUpDocument: {},
    errorsFoPendingWork: {},
    errorsManagersClaimDecision: {},
    errorReportMakerAllocationData: {},
    errorReportForQCData: {},
    errorsReportUploadDocument: {},
    errorsDeleteHealthReport: {},
    errorReportForTeamLeaderQCData: {},
    errorReportForSubmissionData: {},
    errorFinalCloseData: {},
    errorFinalClosureDocumentData: {},
    errorFqcRemarkFo: {},
    errorsendForRereport: {},
    errorsReworkRemark: {},
    errorsRequestChangeDecision: {},
    errorsAcceptRejectRequestDecision: {},
    errorsEditChangeDecision: {},
    errorsReportDetails: {},
    errorsAllReportDetails: {},
    errorsSingleReportDetails: {},
    savedHealthID: "",
    errorQcManagerAllocation: {},
    errorFoDraft: {},
    errorsCaseHospitalDetails: {},
    errorsDeleteCaseHospitalDetails: {},
    errorsCaseLogs: {},
}

const basicSaveReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_BASICSAVELIST_PENDING":
        case "ADD_BASICSAVE_PENDING":
        case "ADD_FQC_REMARK_FO_PENDING":
        case "ADD_REREPORT_PENDING":
        case "ADD_REWORK_REMARK_PENDING":
        case "ADD_REQUEST_CHANGE_DECISION_PENDING":
        case "ACCEPT_REJECT_REQUEST_DECISION_PENDING":
        case "EDIT_CHANGE_DECISION_PENDING":
        case "ADD_TREATING_DOCTOR_DATA_PENDING":
        case "ADD_REFERRAL_DOCTOR_DATA_PENDING":
        case "ADD_FAMILY_DOCTOR_DATA_PENDING":
        case "ADD_PATHOLOGIST_DOCTOR_DATA_PENDING":
        case "ADD_RADIOLOGIST_DOCTOR_DATA_PENDING":
        case "ADD_PHARMACY_DATA_PENDING":
        case "GET_FO_PENDING_WORK_LIST_PENDING":
        case "GET_REPORT_MAKER_PENDING_WORK_LIST_PENDING":
        case "GET_QC_MANAGER_PENDING_WORK_LIST_PENDING":
        case "GET_RELATED_SEARCH_LIST_PENDING":
        case "ADD_BULLET_MANAGEMENT_ALLOCATION_PENDING":
        case "ADD_BULLET_MANAGEMENT_CLAIM_PENDING":
        case "ADD_ASSIGN_FO_ALLOCATION_PENDING":
        case "ADD_FO_DRAFT_PENDING":
        case "DELETE_FO_DRAFT_PENDING":
        case "DELETE_FO_DOCUMENT_PENDING":
        case "SAVE_FO_DOCUMENT_NAME_PENDING":
        case "ADD_CLAIM_FOLLOW_UP_FO_CHANGE_REQUEST_PENDING":
        case "ADD_CLAIM_FOLLOW_UP_ESCALATION_REQUEST_PENDING":
        case "ADD_INTERNAL_TRIGGER_PENDING":
        case "ADD_SINGLE_INTERNAL_TRIGGER_PENDING":
        case "ADD_INTERNAL_TRIGGER_DOCUMENT_PENDING":
        case "ADD_CLAIM_FOLLOW_UP_PENDING":
        case "ADD__NEW_FO_REQUEST_PENDING":
        case "ADD_CLAIM_FOLLOW_UP_DOCUMENT_PENDING":
        case "ADD_FO_PENDING_WORK_PENDING":
        case "ADD_MANAGERS_CLAIM_DECISION_PENDING":
        case "GET_BULLET_MANAGEMENT_LIST_PENDING":
        case "UPDATE_BASICSAVE_PENDING":
        case "UPDATE_BASICSAVE_STATUS_PENDING":
        case "DELETE_BASICSAVE_PENDING":
        case "DELETE_DOCUMENT_REMARK_PENDING":
        case "DELETE_CASE_HOSPITAL_DETAILS_PENDING":
        case "GET_BASICSAVELISTBYID_PENDING":
        case "GET_CASE_LOGS_BYID_PENDING":
        case "GET_REPORTDETAILSLISTBYID_PENDING":
        case "GET_REPORTDETAILSLISTBYID_CASHLESS_PENDING":
        case "GET_ALL_REPORT_DETAILS_PENDING":
        case "GET_SINGLE_REPORT_DETAILS_PENDING":
        case "ADD_REPORT_DETAILS_PENDING":
        case "ADD_REPORT_DETAILS_CASHLESS_PENDING":
        case "ADD_REPORT_MAKER_REMARK_PENDING":
        case "ADD_ALLOCATION_STATUS_PENDING":
        case "ADD_REWORK_STATUS_PENDING":
        case "ADD_FO_CHANGE_STATUS_PENDING":
        case "ADD_FO_DOCUMENT_PENDING":
        case "WITHDRAW_CASE_FO_PENDING":
        case "RESEND_AL_TO_FO_PENDING":
        case "EDIT_TASK_FIELD_OFFICER_PENDING":
        case "FORCE_FO_FINAL_SUBMITTED_PENDING":
        case "FQC_SEND_TO_FO_PENDING":
        case "FQC_SEND_TO_QC_PENDING":
        case "ADD_REPORT_ALLOCATION_PENDING":
        case "ADD_REPORT_QC_PENDING":
        case "ADD_REPORT_TEAM_LEADER_QC_PENDING":
        case "ADD_REPORT_SUBMISSION_PENDING":
        case "ADD_FINAL_CLOSURE_DOCUMENT_PENDING":
        case "ADD_FINAL_CLOSE_PENDING":
        case "ADD_QC_MANAGER_ALLOCATION_PENDING":
        case "UPDATE_REPORT_DETAILS_PENDING":
        case "ADD_INVESTIGATION_EXTERNAL_PENDING":
        case "ADD_REINVESTIGATION_EXTERNAL_PENDING":
            return { ...state, loadingBasicSave: true };
        case "UPDATE_REPORT_DETAILS_CASHLESS_PENDING":
            return { ...state, loadingUpdateReportDetailsCashless: true };
        case "UPDATE_CLAIMTYPE_PENDING":
            return { ...state, loadingClaimTypeSave: true };
        case "UPDATE_TASKMANAGEMENT_PENDING":
            return { ...state, loadingTaskManagementSave: true };
        case "UPDATE_TRIGGER_PENDING":
            return { ...state, loadingtriggerSave: true };
        case "UPDATE_CASEDETAILS_PENDING":
            return { ...state, loadingCaseDetailsSave: true };
        case "GET_DELETED_FO_DOCUMENTS_PENDING":
            return { ...state, loadingDeletedFoDocuments: true };
        case "GET_CASE_SPOC_TEAMS_PENDING":
            return {
                ...state,
                loadingCaseSpocTeams: true,
                caseSpocTeams: null,
                caseSpocTeamsHealthId: action.healthId ?? null,
            };
        case "UPDATE_CASE_HOSPITAL_DETAILS_PENDING":
            return { ...state, loadingCaseHospitalDetailsSave: true };
        case "UPDATE_TAT_PENDING":
            return { ...state, loadingtatSave: true };
        case "UPLOAD_REMARKS_PENDING":
            return { ...state, loadingUploadRemarksSave: true };
        case "UPDATE_REMARKS_PENDING":
            return { ...state, loadingremarkSave: true };
        case "UPDATE_FO_PENDING_WORK_REMARK_PENDING":
            return { ...state, loadingFoPendingWorkRemark: true, errorsFoPendingWorkRemark: {} };
        case "UPLOAD_REPORT_DOCUMENT_PENDING":
            return {
                ...state,
                loadingReportUploadDocument: true,
                errorsReportUploadDocument: {},
            };
        case "DELETE_HEALTH_REPORT_PENDING":
            return {
                ...state,
                loadingDeleteHealthReport: true,
                deletingHealthReportId: action.reportId ?? null,
                errorsDeleteHealthReport: {},
            };

        case "GET_BASICSAVELIST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                basicSaveLists: action.payload,
                basicSaveCount: action.count,
                basicSavePermissions: action.permissions,
            };

        case "ADD__NEW_FO_REQUEST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                newFoRequestData: action.payload,
                errorsNewFoRequest: {},
            };

        case "ADD_BASICSAVE_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: action.payload,
                errorsBasicSave: {},
            };
        case "ADD_TREATING_DOCTOR_DATA_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                treatingDoctorData: action.payload,
                errorsBasicSave: {},
            };
        case "ADD_REFERRAL_DOCTOR_DATA_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                referralDoctorData: action.payload,
                errorsBasicSave: {},
            };
        case "ADD_FAMILY_DOCTOR_DATA_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                familyDoctorData: action.payload,
                errorsBasicSave: {},
            };
        case "ADD_PATHOLOGIST_DOCTOR_DATA_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                pathologistDoctorData: action.payload,
                errorsBasicSave: {},
            };
        case "ADD_RADIOLOGIST_DOCTOR_DATA_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                radiologistDoctorData: action.payload,
                errorsBasicSave: {},
            };
        case "ADD_PHARMACY_DATA_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                pharmacyData: action.payload,
                errorsBasicSave: {},
            };
        case "UPDATE_CLAIMTYPE_FULFILLED":
            return {
                ...state,
                loadingClaimTypeSave: false,
                changedBasicSaveStatus: action.payload,
                errorsClaimTypeSave: {},
            };
        case "UPDATE_TRIGGER_FULFILLED":
            return {
                ...state,
                loadingtriggerSave: false,
                changedBasicSaveStatus: action.payload,
                errorstriggerSave: {},
            };
        case "UPDATE_TASKMANAGEMENT_FULFILLED":
            return {
                ...state,
                loadingTaskManagementSave: false,
                changedBasicSaveStatus: action.payload,
                errorsTaskManagementSave: {},
            };

        case "UPDATE_BASICSAVE_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: action.payload,
            };

        case "UPDATE_BASICSAVE_STATUS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: action.payload,
            };
        case "UPDATE_CASEDETAILS_FULFILLED":
            return {
                ...state,
                loadingCaseDetailsSave: false,
                changedBasicSaveStatus: action.payload,
            };
        case "UPDATE_CASE_HOSPITAL_DETAILS_FULFILLED":
            return {
                ...state,
                loadingCaseHospitalDetailsSave: false,
                changedBasicSaveStatus: action.payload,
            };
        case "UPDATE_TAT_FULFILLED":
            return {
                ...state,
                loadingtatSave: false,
                changedBasicSaveStatus: action.payload,
            };
        case "UPLOAD_REMARKS_FULFILLED":
            return {
                ...state,
                loadingUploadRemarksSave: false,
                changedBasicSaveStatus: {
                    ...(action.payload || {}),
                    basicSaveOperation: "uploadDocumentRemark",
                },
            };
        case "UPDATE_REMARKS_FULFILLED":
            return {
                ...state,
                loadingremarkSave: false,
                changedBasicSaveStatus: action.payload,
            };
        case "UPDATE_FO_PENDING_WORK_REMARK_FULFILLED":
            return {
                ...state,
                loadingFoPendingWorkRemark: false,
                foPendingWorkRemarkData: action.payload,
                errorsFoPendingWorkRemark: {},
            };
        case "UPLOAD_REPORT_DOCUMENT_FULFILLED":
            return {
                ...state,
                loadingReportUploadDocument: false,
                reportUploadDocumentData: action.payload,
                errorsReportUploadDocument: {},
            };
        case "DELETE_HEALTH_REPORT_FULFILLED":
            return {
                ...state,
                loadingDeleteHealthReport: false,
                deletingHealthReportId: null,
                deleteHealthReportData: action.payload,
                reportUploadDocumentData: null,
                errorsDeleteHealthReport: {},
            };

        case "GET_BASICSAVELISTBYID_FULFILLED": {
            // Safety net: POST partial payloads merge into existing case details so
            // Redux never loses unrelated keys (same stored shape as a full refetch).
            let nextDetails = action.payload;
            if (nextDetails && nextDetails._partial === true) {
                const hasExisting =
                    state.basicSaveDetails &&
                    Object.keys(state.basicSaveDetails).length > 1;
                if (hasExisting) {
                    const replaceKeys = Array.isArray(nextDetails._partialReplace)
                        ? nextDetails._partialReplace
                        : [];
                    const merged = { ...state.basicSaveDetails };
                    replaceKeys.forEach((key) => {
                        if (nextDetails[key] !== undefined) merged[key] = nextDetails[key];
                    });
                    const appendKey = nextDetails._partialAppend;
                    if (appendKey && nextDetails[appendKey] !== undefined) {
                        const existing = Array.isArray(merged[appendKey])
                            ? merged[appendKey]
                            : [];
                        const incoming = Array.isArray(nextDetails[appendKey])
                            ? nextDetails[appendKey]
                            : [nextDetails[appendKey]];
                        merged[appendKey] = [...existing, ...incoming];
                    }
                    merged.id =
                        nextDetails.id ?? merged.id ?? Number(nextDetails.health_id);
                    delete merged._partial;
                    delete merged._partialReplace;
                    delete merged._partialAppend;
                    nextDetails = merged;
                } else {
                    const cleaned = { ...nextDetails };
                    delete cleaned._partial;
                    delete cleaned._partialReplace;
                    delete cleaned._partialAppend;
                    nextDetails = cleaned;
                }
            }
            // Soft-TTL: treat any successful details write (full or merged) as fresh.
            try {
                const id = nextDetails?.id ?? nextDetails?.health_id;
                if (id != null) {
                    const { markBasicSaveDetailsFetched } = require("../basicSaveDetailsCache");
                    markBasicSaveDetailsFetched(id);
                }
            } catch (_) {
                /* ignore — cache mark is best-effort */
            }
            return {
                ...state,
                loadingBasicSave: false,
                basicSaveDetails: nextDetails,
                basicSavePermissions: action.permissions !== undefined ? action.permissions : state.basicSavePermissions,
            };
        }

        case "GET_CASE_LOGS_BYID_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                caseLogsData: action.payload,
                caseLogsPermissions: action.permissions,
            };

        case "GET_REPORTDETAILSLISTBYID_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportDetailsList: action.payload,
            };

        case "GET_REPORTDETAILSLISTBYID_CASHLESS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportDetailsList: action.payload,
            };

        case "GET_FO_PENDING_WORK_LIST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                foPendingWorkListData: action.payload,
            };  

        case "GET_ALL_REPORT_DETAILS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                allReportDetailsData: action.payload,
            };

        case "ADD_REPORT_MAKER_REMARK_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportMakerRemarkData: action.payload,
            };

        case "GET_SINGLE_REPORT_DETAILS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                singleReportDetailsData: action.payload,
            };

        case "ADD_REPORT_DETAILS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportDetailsData: action.payload,
                errorsReportDetails: {},
            };

        case "ADD_REPORT_DETAILS_CASHLESS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                loadingReportDetailsCashless: false,
                reportDetailsCashless: action.payload,
                errorsReportDetailsCashless: {},
            };

        case "UPDATE_REPORT_DETAILS_CASHLESS_FULFILLED":
            return {
                ...state,
                loadingUpdateReportDetailsCashless: false,
                updateReportDetailCashless: action.payload,
                errorsUpdateReportDetailsCashless: {},
            };

        case "GET_BULLET_MANAGEMENT_LIST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                bulletManagementData: action.payload,
                bulletManagementClientCompanyId:
                  action.clientCompanyId ?? state.bulletManagementClientCompanyId,
            };

        case "GET_CASE_SPOC_TEAMS_FULFILLED":
            return {
                ...state,
                loadingCaseSpocTeams: false,
                caseSpocTeams: Array.isArray(action.payload) ? action.payload : [],
                caseSpocTeamsHealthId: action.healthId ?? state.caseSpocTeamsHealthId,
            };

        case "GET_REPORT_MAKER_PENDING_WORK_LIST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportMakerPendingWorkListData: action.payload,
            };

        case "GET_QC_MANAGER_PENDING_WORK_LIST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                qcManagerPendingWorkListData: action.payload,
            };

        case "ADD_BULLET_MANAGEMENT_ALLOCATION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                bulletManagementAllocationData: action.payload,
                errorsBulletAllocation: {},
            };

        case "ADD_BULLET_MANAGEMENT_CLAIM_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                bulletManagementClaimData: action.payload,
                errorsBulletClaimTeam: {},
            };

        case "ADD_ASSIGN_FO_ALLOCATION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                assignFoAllocationData: action.payload,
                errorsAssignFoAllocation: {},
            };

        case "ADD_ALLOCATION_STATUS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                allocationStatusData: action.payload,
                errorsAllocationStatus: {},
            };

        case "ADD_REWORK_STATUS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reworkStatusData: action.payload,
                errorsReworkStatus: {},
            };

        case "DELETE_DOCUMENT_REMARK_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: {
                    ...(action.payload || {}),
                    basicSaveOperation: "deleteDocumentRemark",
                },
            };

        case "DELETE_CASE_HOSPITAL_DETAILS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: action.payload,
            };

        case "ADD_FO_CHANGE_STATUS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                foChangeStatusData: action.payload,
                errorsFoChangeStatus: {},
            };

        case "ADD_FO_DOCUMENT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                foDocumentData: action.payload,
                errorsFoDocument: {},
            };
        case "ADD_INVESTIGATION_EXTERNAL_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                investigationExternalData: action.payload,
                errorsInvestigationExternal: {},
            };

        case "ADD_REINVESTIGATION_EXTERNAL_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reinvestigationExternalData: action.payload,
                errorsReinvestigationExternal: {},
            };

        case "WITHDRAW_CASE_FO_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                withdrawCaseFoData: action.payload,
                errorsWithdrawCaseFo: {},
            };

        case "RESEND_AL_TO_FO_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                resendALToFOData: action.payload,
                errorsResendALToFO: {},
            };

        case "EDIT_TASK_FIELD_OFFICER_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                editTaskFieldOfficerData: action.payload,
                errorsEditTaskFieldOfficer: {},
            };

        case "FORCE_FO_FINAL_SUBMITTED_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                forceFoFinalSubmittedData: action.payload,
                errorsForceFoFinalSubmitted: {},
            };

        case "FQC_SEND_TO_FO_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                fqcSendToFoData: action.payload,
                errorsFqcSendToFo: {},
            };

        case "FQC_SEND_TO_QC_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                fqcSendToQcData: action.payload,
                errorsFqcSendToQc: {},
            };

        case "ADD_CLAIM_FOLLOW_UP_FO_CHANGE_REQUEST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpChangeData: action.payload,
                errorsClaimFollowUpChange: {},
            };

        case "ADD_CLAIM_FOLLOW_UP_ESCALATION_REQUEST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpEscalationData: action.payload,
                errorsClaimFollowUpEscalation: {},
            };

        case "ADD_INTERNAL_TRIGGER_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                internalTriggerData: action.payload,
                errorsInternalTrigger: {},
            };

        case "ADD_SINGLE_INTERNAL_TRIGGER_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                singleInternalTriggerData: action.payload,
                errorsSingleInternalTrigger: {},
            };

        case "ADD_INTERNAL_TRIGGER_DOCUMENT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                internalTriggerDocumentData: action.payload,
                errorsInternalTriggerDocument: {},
            };

        case "GET_RELATED_SEARCH_LIST_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                relatedSearchListData: action.payload,
            };

        case "ADD_CLAIM_FOLLOW_UP_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpData: action.payload,
                errorsCLaimFollowUp: {},
            };

        case "ADD_CLAIM_FOLLOW_UP_DOCUMENT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpDocumentData: action.payload,
                errorsCLaimFollowUpDocument: {},
            };

        case "ADD_FO_PENDING_WORK_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                foPendingWorkData: action.payload,
                errorsFoPendingWork: {},
            };

        case "ADD_MANAGERS_CLAIM_DECISION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                managersClaimDecisionData: action.payload,
                errorsManagersClaimDecision: {},
            };

        case "ADD_FO_DRAFT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                foDraftData: action.payload,
                errorFoDraft: {},
            };

        case "ADD_REPORT_ALLOCATION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportMakerAllocationData: action.payload,
                errorReportMakerAllocationData: {},
            };
        case "ADD_REPORT_QC_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportForQCData: action.payload,
                errorReportForQCData: {},
            };

        case "ADD_REPORT_TEAM_LEADER_QC_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportForTeamLeaderQCData: action.payload,
                errorReportForTeamLeaderQCData: {},
            };

        case "ADD_REPORT_SUBMISSION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportForSubmissionData: action.payload,
                errorReportForSubmissionData: {},
            };
            case "ADD_FINAL_CLOSURE_DOCUMENT_FULFILLED":
                return {
                    ...state,
                    loadingBasicSave: false,
                    finalClosureDocumentData: action.payload,
                    errorFinalClosureDocumentData: {},
                };
        case "ADD_FINAL_CLOSE_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                finalCloseData: action.payload,
                errorFinalCloseData: {},
            };
        case "UPDATE_REPORT_DETAILS_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reportDetailsData: action.payload,
                errorsBasicSave: {},
            };
        
        case "ADD_FQC_REMARK_FO_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                fqcRemarkFo: action.payload,
                errorFqcRemarkFo: {},
            };
        
        case "ADD_REREPORT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                sendForRereport: action.payload,
                errorsendForRereport: {},
            };

        case "ADD_REWORK_REMARK_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                reworkRemarkData: action.payload,
                errorsReworkRemark: {},
            };
        
        case "ADD_REQUEST_CHANGE_DECISION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                requestChangeDecisionData: action.payload,
                errorsRequestChangeDecision: {},
            };

        case "ACCEPT_REJECT_REQUEST_DECISION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                acceptRejectRequestDecisionData: action.payload,
                errorsAcceptRejectRequestDecision: {},
            };

        case "EDIT_CHANGE_DECISION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                editChangeDecisionData: action.payload,
                errorsEditChangeDecision: {},
            };

        case "ADD_QC_MANAGER_ALLOCATION_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                qcManagerAllocationData: action.payload,
                errorQcManagerAllocation: {},
            };

        case "DELETE_BASICSAVE_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: action.payload
            };

        case "DELETE_FO_DRAFT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                deleteFoDraftData: action.payload,
                errorsDeleteFoDraft: {},
            };

        case "DELETE_FO_DOCUMENT_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                deleteFoDocumentData: action.payload,
                errorsDeleteFoDocument: {},
            };

        case "GET_DELETED_FO_DOCUMENTS_FULFILLED":
            return {
                ...state,
                loadingDeletedFoDocuments: false,
                deletedFoDocumentsData: action.payload,
                errorsDeletedFoDocuments: {},
            };

        case "SAVE_FO_DOCUMENT_NAME_FULFILLED":
            return {
                ...state,
                loadingBasicSave: false,
                saveFoDocumentNameData: action.payload,
                errorsSaveFoDocumentName: {},
            };

        case "RESET_DELETE_BASICSAVES_STATUS":
            return {
                ...state,
                loadingBasicSave: false,
                loadingClaimTypeSave: false,
                loadingtriggerSave: false,
                loadingTaskManagementSave: false,
                loadingCaseDetailsSave: false,
                loadingtatSave: false,
                loadingUploadRemarksSave: false,
                loadingremarkSave: false,
                changedBasicSaveStatus: [],
                errorsBasicSave: {},
                errorsClaimTypeSave: {},
                errorstriggerSave: {},
                errorsTaskManagementSave: {},
                errorsCaseDetailsSave: {},
                errorstatSave: {},
                errorsUploadRemarksSave: {},
                errorsRemarksSave: {},
                
            };

        case "GET_BASICSAVELIST_REJECTED":
        case "ADD_BASICSAVE_REJECTED":
        case "ADD_REQUEST_CHANGE_DECISION_REJECTED":
        case "ACCEPT_REJECT_REQUEST_DECISION_REJECTED":
        case "EDIT_CHANGE_DECISION_REJECTED":
        case "ADD_TREATING_DOCTOR_DATA_REJECTED":
        case "ADD_REFERRAL_DOCTOR_DATA_REJECTED":
        case "ADD_FAMILY_DOCTOR_DATA_REJECTED":
        case "ADD_PATHOLOGIST_DOCTOR_DATA_REJECTED":
        case "ADD_RADIOLOGIST_DOCTOR_DATA_REJECTED":
        case "ADD_PHARMACY_DATA_REJECTED":
        case "GET_BULLET_MANAGEMENT_LIST_REJECTED":
        case "ADD_BULLET_MANAGEMENT_ALLOCATION_REJECTED":
        case "ADD_BULLET_MANAGEMENT_CLAIM_REJECTED":
        case "UPDATE_BASICSAVE_REJECTED":
        case "UPDATE_BASICSAVE_STATUS_REJECTED":
        case "DELETE_BASICSAVE_REJECTED":
        case "DELETE_DOCUMENT_REMARK_REJECTED":
        case "DELETE_CASE_HOSPITAL_DETAILS_REJECTED":
        case "GET_BASICSAVELISTBYID_REJECTED":
        case "GET_CASE_LOGS_BYID_REJECTED":
        case "GET_REPORTDETAILSLISTBYID_REJECTED":
        case "GET_ALL_REPORT_DETAILS_REJECTED":
        case "GET_SINGLE_REPORT_DETAILS_REJECTED":
        case "ADD_REPORT_DETAILS_REJECTED":
        case "ADD_REPORT_MAKER_REMARK_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsBasicSave: action.payload
            };
        case "ADD_REPORT_DETAILS_CASHLESS_REJECTED":
            return {
                ...state,
                loadingReportDetailsCashless: false,
                errorsReportDetailsCashless: action.payload
            };
        case "UPDATE_REPORT_DETAILS_CASHLESS_REJECTED":
            return {
                ...state,
                loadingUpdateReportDetailsCashless: false,
                errorsUpdateReportDetailsCashless: action.payload
            };
        case "UPDATE_CLAIMTYPE_REJECTED":
            return {
                ...state,
                loadingClaimTypeSave: false,
                errorsClaimTypeSave: action.payload
            };
        case "UPDATE_TASKMANAGEMENT_REJECTED":
            return {
                ...state,
                loadingTaskManagementSave: false,
                errorsTaskManagementSave: action.payload
            };
        case "UPDATE_TRIGGER_REJECTED":
            return {
                ...state,
                loadingtriggerSave: false,
                errorstriggerSave: action.payload
            };
        case "UPDATE_CASEDETAILS_REJECTED":
            return {
                ...state,
                loadingCaseDetailsSave: false,
                errorsCaseDetailsSave: action.payload
            };

        case "GET_CASE_SPOC_TEAMS_REJECTED":
            return {
                ...state,
                loadingCaseSpocTeams: false,
                errorsCaseSpocTeams: action.payload,
            };

        case "UPDATE_CASE_HOSPITAL_DETAILS_REJECTED":
            return {
                ...state,
                loadingCaseHospitalDetailsSave: false,
                errorsCaseHospitalDetails: action.payload
            };
        case "UPDATE_TAT_REJECTED":
            return {
                ...state,
                loadingtatSave: false,
                errorstatSave: action.payload
            };
        case "UPLOAD_REMARKS_REJECTED":
            return {
                ...state,
                loadingUploadRemarksSave: false,
                errorsUploadRemarksSave: action.payload
            };
        case "UPDATE_REMARKS_REJECTED":
            return {
                ...state,
                loadingremarkSave: false,
                errorsRemarksSave: action.payload
            };
        case "UPDATE_FO_PENDING_WORK_REMARK_REJECTED":
            return {
                ...state,
                loadingFoPendingWorkRemark: false,
                errorsFoPendingWorkRemark: action.payload,
            };
        case "UPLOAD_REPORT_DOCUMENT_REJECTED":
            return {
                ...state,
                loadingReportUploadDocument: false,
                reportUploadDocumentData: null,
                errorsReportUploadDocument: action.payload
            };
        case "DELETE_HEALTH_REPORT_REJECTED":
            return {
                ...state,
                loadingDeleteHealthReport: false,
                deletingHealthReportId: null,
                errorsDeleteHealthReport: action.payload,
            };

        case "GET_BULLET_MANAGEMENT_LIST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsBasicSave: action.payload
            };

        case "GET_RELATED_SEARCH_LIST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsRelatedSearchList: action.payload
            };

        case "GET_FO_PENDING_WORK_LIST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsFoPendingWorkList: action.payload
            };

        case "GET_REPORT_MAKER_PENDING_WORK_LIST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReportMakerPendingWorkList: action.payload
            };

        case "GET_QC_MANAGER_PENDING_WORK_LIST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsQcManagerPendingWorkList: action.payload
            };

        case "ADD_BULLET_MANAGEMENT_ALLOCATION_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsBulletAllocation: {},
            };

        case "ADD_BULLET_MANAGEMENT_CLAIM_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsBulletClaimTeam: {},
            };

        case "ADD_ASSIGN_FO_ALLOCATION_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsAssignFoAllocation: {},
            };

        case "ADD_ALLOCATION_STATUS_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsAllocationStatus: {},
            };

        case "ADD_REWORK_STATUS_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReworkStatus: {},
            };

            case "ADD_FO_CHANGE_STATUS_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsFoChangeStatus: {},
            };

        case "ADD_FO_DOCUMENT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsFoDocument: action.payload || {},
            };
        case "ADD_INVESTIGATION_EXTERNAL_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsInvestigationExternal: {},
            };

        case "ADD_REINVESTIGATION_EXTERNAL_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReinvestigationExternal: {},
            };

        case "WITHDRAW_CASE_FO_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsWithdrawCaseFo: action.payload,
            };

        case "RESEND_AL_TO_FO_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsResendALToFO: action.payload,
            };

        case "EDIT_TASK_FIELD_OFFICER_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsEditTaskFieldOfficer: action.payload,
            };

        case "FORCE_FO_FINAL_SUBMITTED_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsForceFoFinalSubmitted: action.payload,
            };

        case "FQC_SEND_TO_FO_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsFqcSendToFo: action.payload,
            };

        case "FQC_SEND_TO_QC_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsFqcSendToQc: action.payload,
            };

        case "ADD_CLAIM_FOLLOW_UP_FO_CHANGE_REQUEST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsClaimFollowUpChange: {},
            };

        case "ADD__NEW_FO_REQUEST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsNewFoRequest: action.payload,
            };

        case "ADD_CLAIM_FOLLOW_UP_ESCALATION_REQUEST_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsClaimFollowUpEscalation: {},
            };

        case "ADD_INTERNAL_TRIGGER_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsInternalTrigger: {},
            };

        case "ADD_SINGLE_INTERNAL_TRIGGER_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsSingleInternalTrigger: {},
            };

        case "ADD_INTERNAL_TRIGGER_DOCUMENT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsInternalTriggerDocument: {},
            };

        case "ADD_CLAIM_FOLLOW_UP_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsCLaimFollowUp: {},
            };

        case "ADD_CLAIM_FOLLOW_UP_DOCUMENT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsCLaimFollowUpDocument: {},
            };

        case "ADD_FO_PENDING_WORK_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsFoPendingWork: {},
            };

        case "ADD_MANAGERS_CLAIM_DECISION_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsManagersClaimDecision: {},
            };

        case "ADD_FO_DRAFT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorFoDraft: {},
            };

        case "DELETE_FO_DRAFT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsDeleteFoDraft: action.payload,
            };

        case "DELETE_FO_DOCUMENT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsDeleteFoDocument: action.payload,
            };

        case "GET_DELETED_FO_DOCUMENTS_REJECTED":
            return {
                ...state,
                loadingDeletedFoDocuments: false,
                errorsDeletedFoDocuments: action.payload || {},
            };

        case "SAVE_FO_DOCUMENT_NAME_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsSaveFoDocumentName: action.payload || {},
            };

        case "ADD_REPORT_ALLOCATION_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorReportMakerAllocationData: {},
            };
        case "ADD_REPORT_QC_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorReportForQCData: {},
            };
        case "ADD_REPORT_TEAM_LEADER_QC_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorReportForTeamLeaderQCData: {},
            };
        case "ADD_REPORT_SUBMISSION_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorReportForSubmissionData: {},
            };
        case "ADD_FINAL_CLOSURE_DOCUMENT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorFinalClosureDocumentData: action.payload || {
                    message: "Network error",
                    status: null,
                },
            };
        case "ADD_FINAL_CLOSE_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorFinalCloseData: {},
            };
        case "UPDATE_REPORT_DETAILS_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReportDetails: {},
            };

        case "GET_REPORTDETAILSLISTBYID_CASHLESS_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReportDetailsCashless: {},
            };

        case "ADD_FQC_REMARK_FO_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorFqcRemarkFo: {},
            };

        case "ADD_REREPORT_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsendForRereport: {},
            };

        case "ADD_REWORK_REMARK_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReworkRemark: action.payload,
            };
        
        case "ADD_QC_MANAGER_ALLOCATION_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorQcManagerAllocation: action.payload,
            };

        case "ADD_REPORT_DETAILS_REJECTED":
            return {
                ...state,
                loadingBasicSave: false,
                errorsReportDetails: {},
            };

        case "RESET_BASICDETAILS":
            return {
                ...state,
                loadingtatSave: false,
                basicSaveDetails: {}
            };

        case "RESET_FO_PENDING_WORK_LIST":
            return {
                ...state,
                loadingBasicSave: false,
                foPendingWorkListData: {}
            };

        case "RESET_REPORT_MAKER_PENDING_WORK_LIST":
            return {
                ...state,
                loadingBasicSave: false,
                reportMakerPendingWorkListData: {}
            };

        case "RESET_QC_MANAGER_PENDING_WORK_LIST":
            return {
                ...state,
                loadingBasicSave: false,
                qcManagerPendingWorkListData: {}
            };

        case "RESET_REPORTDETAILS":
            return {
                ...state,
                loadingtatSave: false,
                reportDetailsList: {}
            };

        case "RESET_SAVE_REPORT_DETAILS":
            return {
                ...state,
                loadingBasicSave: false,
                reportDetailsData: {}
            };

        case "RESET_ALL_REPORT_DETAILS":
            return {
                ...state,
                loadingBasicSave: false,
                allReportDetailsData: {}
            };

        case "RESET_SINGLE_REPORT_DETAILS":
            return {
                ...state,
                loadingBasicSave: false,
                singleReportDetailsData: {}
            };

        case "RESET_BULLET_ALLOCATION":
            return {
                ...state,
                loadingBasicSave: false,
                bulletManagementAllocationData: {}
            };

        case "RESET_BULLET_CLAIM_TEAM":
            return {
                ...state,
                loadingBasicSave: false,
                bulletManagementClaimData: {}
            };

        case "RESET_ASSIGN_FO_ALLOCATION":
            return {
                ...state,
                loadingBasicSave: false,
                assignFoAllocationData: {}
            };

        case "RESET_FO_DRAFT":
            return {
                ...state,
                loadingBasicSave: false,
                foDraftData: {}
            };


        case "RESET_CASE_SPOC_TEAMS":
            return {
                ...state,
                loadingCaseSpocTeams: false,
                caseSpocTeams: null,
                caseSpocTeamsHealthId: null,
            };

        case "RESET_DELETE_FO_DRAFT":
            return {
                ...state,
                loadingBasicSave: false,
                deleteFoDraftData: {},
                errorsDeleteFoDraft: {},
            };

        case "RESET_SAVE_FO_DOCUMENT_NAME":
            return {
                ...state,
                loadingBasicSave: false,
                saveFoDocumentNameData: {},
                errorsSaveFoDocumentName: {},
            };

        case "RESET_DELETE_FO_DOCUMENT":
            return {
                ...state,
                loadingBasicSave: false,
                deleteFoDocumentData: {},
                errorsDeleteFoDocument: {},
            };

        case "RESET_CLAIM_FOLLOW_UP_FO_CHANGE":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpChangeData: {}
            };

        case "RESET_CLAIM_FOLLOW_UP_ESCALATION":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpEscalationData: {}
            };

        case "RESET_ADD_INTERNAL_TRIGGER":
            return {
                ...state,
                loadingBasicSave: false,
                internalTriggerData: {}
            };

        case "RESET_ADD_SINGLE_INTERNAL_TRIGGER":
            return {
                ...state,
                loadingBasicSave: false,
                singleInternalTriggerData: {}
            };

        case "RESET_ADD_INTERNAL_TRIGGER_DOCUMENT":
            return {
                ...state,
                loadingBasicSave: false,
                internalTriggerDocumentData: {}
            };

        case "RESET_ADD_CLAIM_FOLLOW_UP":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpData: {}
            };

        case "RESET_ADD_CLAIM_FOLLOW_UP_DOCUMENT":
            return {
                ...state,
                loadingBasicSave: false,
                claimFollowUpDocumentData: {}
            };

        case "RESET_FO_PENDING_WORK":
            return {
                ...state,
                loadingBasicSave: false,
                foPendingWorkData: {}
            };

            case "ADD_REPORT_MAKER_ALLOCATION_RESET":
            return {
                ...state,
                reportMakerAllocation: [],
            };

        case "ADD_QC_MANAGER_ALLOCATION_RESET":
            return {
                ...state,
                qcManagerAllocationData: [],
            };

        case "ADD_REPORT_TEAM_LEADER_QC_RESET":
            return {
                ...state,
                reportForTeamLeaderQCData: [],
            };

        case "RESET_MANAGER_CLAIM_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                managersClaimDecisionData: {}
            };
        case "RESET_REPORT_ALLOCATION_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                reportMakerAllocationData: {}
            };
        case "RESET_REPORT_QC_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                reportForQCData: {}
            };
        case "RESET_REPORT_SUBMISSION_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                reportForSubmissionData: {}
            };
        case "RESET_FINAL_CLOSURE_DOCUMENT_DATA":
            return {
                ...state,
                loadingBasicSave: false,
                finalClosureDocumentData: {}
            };
        case "RESET_FINAL_CLOSE_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                finalCloseData: {}
            };

        case "RESET_ADD_FQC_REMARK_FO":
            return {
                ...state,
                loadingBasicSave: false,
                fqcRemarkFo: {}
            };

        case "RESET_ADD_REREPORT":
            return {
                ...state,
                loadingBasicSave: false,
                sendForRereport: {}
            };

        case "RESET_REWORK_REMARK":
            return {
                ...state,
                loadingBasicSave: false,
                reworkRemarkData: {}
            };

        case "RESET_REQUEST_CHANGE_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                requestChangeDecisionData: {}
            };

        case "RESET_ACCEPT_REJECT_REQUEST_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                acceptRejectRequestDecisionData: {}
            };

        case "RESET_EDIT_CHANGE_DECISION":
            return {
                ...state,
                loadingBasicSave: false,
                editChangeDecisionData: {}
            };

        case "RESET_FAMILY_DOCTOR_DATA":
            return {
                ...state,
                familyDoctorData: {}
            };
        case "RESET_TREATING_DOCTOR_DATA":
            return {
                ...state,
                treatingDoctorData: {}
            };
        case "RESET_REFERRAL_DOCTOR_DATA":
            return {
                ...state,
                referralDoctorData: {}
            };
        case "RESET_PATHOLOGIST_DOCTOR_DATA":
            return {
                ...state,
                pathologistDoctorData: {}
            };
        case "RESET_RADIOLOGIST_DOCTOR_DATA":
            return {
                ...state,
                radiologistDoctorData: {}
            };
        case "RESET_PHARMACY_DATA":
            return {
                ...state,
                pharmacyData: {}
            };
        case "RESET_REPORT_MAKER_REMARK_DATA":
            return {
                ...state,
                reportMakerRemarkData: {}
            };

        case "RESET_ALLOCATION_STATUS_DATA":
            return {
                ...state,
                allocationStatusData: {}
            };

        case "RESET_REWORK_STATUS_DATA":
            return {
                ...state,
                reworkStatusData: {}
            };

        case "RESET_FO_CHANGE_STATUS_DATA":
            return {
                ...state,
                foChangeStatusData: {}
            };

        case "RESET_FO_DOCUMENT_DATA":
            return {
                ...state,
                foDocumentData: {},
                errorsFoDocument: {},
            };

        case "RESET_INVESTIGATION_EXTERNAL_DATA":
            return {
                ...state,
                investigationExternalData: {}
            };

        case "RESET_REINVESTIGATION_EXTERNAL_DATA":
            return {
                ...state,
                reinvestigationExternalData: {}
            };

        case "RESET_WITHDRAW_CASE_FO_DATA":
            return {
                ...state,
                withdrawCaseFoData: {}
            };

        case "RESET_RESEND_AL_TO_FO_DATA":
            return {
                ...state,
                resendALToFOData: {}
            };

        case "RESET_EDIT_TASK_FIELD_OFFICER_DATA":
            return {
                ...state,
                editTaskFieldOfficerData: {},
                errorsEditTaskFieldOfficer: {}
            };

        case "RESET_FORCE_FO_FINAL_SUBMITTED_DATA":
            return {
                ...state,
                forceFoFinalSubmittedData: {}
            };

        case "RESET_FQC_SEND_TO_FO_DATA":
            return {
                ...state,
                fqcSendToFoData: {}
            };
            
        case "RESET_FQC_SEND_TO_QC_DATA":
            return {
                ...state,
                fqcSendToQcData: {}
            };

        case "RESET_REPORT_DETAILS_CASHLESS_DATA":
            return {
                ...state,
                reportDetailsCashless: {},
                errorsReportDetailsCashless: {}
            };

        case "RESET_UPDATE_REPORT_DETAILS_CASHLESS_DATA":
            return {
                ...state,
                updateReportDetailCashless: {},
                errorsUpdateReportDetailsCashless: {}
            };

        case "RESET_QC_MANAGER_ALLOCATION_DATA":
            return {
                ...state,
                qcManagerAllocationData: {}
            };

        case "RESET_NEW_FO_REQUEST_DATA":
            return {
                ...state,
                loadingBasicSave: false,
                newFoRequestData: {},
                errorsNewFoRequest: {},
            };
        case "RESET_DELETE_CASE_HOSPITAL_DETAILS_DATA":
            return {
                ...state,
                loadingBasicSave: false,
                changedBasicSaveStatus: [],
                errorsCaseHospitalDetails: {},
            };

        default:
            return state;
    }
}

export default basicSaveReducer;